import { formatInstagramDate } from '../format';
import {
  CONNECTION_STATUS_CLASSES,
  CONNECTION_STATUS_LABELS,
  type InstagramConnectionStatus,
} from '../types';

/** Status pill, shared by the merchant panel, the admin list and the merchant detail card. */
export const InstagramStatusPill = ({ status }: { status: InstagramConnectionStatus }) => (
  <span
    className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${CONNECTION_STATUS_CLASSES[status]}`}
  >
    {CONNECTION_STATUS_LABELS[status]}
  </span>
);

/**
 * The last-fetch line. `lastFetchSucceeded === false` is what actually hides the storefront
 * section (watchman's `getFeed` returns `posts: null` unless the last fetch succeeded), so it
 * is called out explicitly rather than folded into the status pill — a CONNECTED merchant
 * whose last fetch failed still shows no feed.
 */
export const InstagramFetchHealth = ({
  lastFetchAt,
  lastFetchSucceeded,
  lastFetchError,
}: {
  lastFetchAt: string | null;
  lastFetchSucceeded: boolean | null;
  lastFetchError: string | null;
}) => {
  if (lastFetchSucceeded === null && !lastFetchAt) {
    return <span className="text-muted-foreground">Never fetched</span>;
  }
  if (lastFetchSucceeded === false) {
    return (
      <span className="text-red-600">
        Failed {formatInstagramDate(lastFetchAt)}
        {lastFetchError ? ` — ${lastFetchError}` : ''}
      </span>
    );
  }
  return <span className="text-foreground">Succeeded {formatInstagramDate(lastFetchAt)}</span>;
};
